<template>
  <div class="vx-row">
    <div class="vx-col w-full md:w-1/3 mb-base" v-show="$auth.checkRoles(['CashflowReaders', 'CashflowWriter','Admin'])" >
      <vx-card  slot="no-body" :title="$t('CashFlow.Title')" class="text-center greet-user mb-5">
        <ul class="vx-timeline">
          <li v-if="$auth.checkRoles(['CashflowWriter', 'Admin'])">
            <div class="timeline-icon bg-secondary">
              <feather-icon icon="CalendarIcon" svgClasses="text-white stroke-current w-5 h-5" />
            </div>
            <div class="timeline-info">
              <router-link to="/bsg/cashflow/projectLoms">{{ $t("CashFlow.ProjectLom.Title") }}</router-link>
            </div>
          </li>
         <li v-if="$auth.checkRoles(['CashflowWriter', 'Admin'])">
            <div class="timeline-icon bg-secondary">
               <feather-icon icon="CalendarIcon" svgClasses="text-white stroke-current w-5 h-5" />
            </div>
            <div class="timeline-info">
               <router-link to="/bsg/cashflow/corporateLoms">{{ $t("CashFlow.CorporateLom.Title") }}</router-link>
            </div>
          </li>
          <li v-if="$auth.checkRoles(['CashflowWriter', 'Admin'])">
            <div class="timeline-icon bg-secondary">
               <feather-icon icon="FilmIcon" svgClasses="text-white stroke-current w-5 h-5" />
            </div>
            <div class="timeline-info">
               <router-link to="/bsg/cashflow/compilations">{{ $t("CashFlow.Compilation.Title") }}</router-link>
            </div>
          </li>
          <li v-if="$auth.checkRoles(['CashflowReaders', 'Admin'])">
            <div class="timeline-icon bg-secondary">
               <feather-icon icon="BarChart2Icon" svgClasses="text-white stroke-current w-5 h-5" />
            </div>
            <div class="timeline-info">
               <router-link to="/bsg/cashflow/reports/">{{ $t("CashFlow.Reports.Title") }}</router-link>
            </div>
          </li>
        </ul>
      </vx-card>
    </div>
    <div class="vx-col w-full md:w-1/3 mb-base" >
      <vx-card  slot="no-body" :title="$t('CashFlow.Template.Title')" class="text-center greet-user mb-5" v-show="$auth.checkRoles(roles.writers)">
        <menu-control :items="templateItems">
        </menu-control>
      </vx-card>
    </div>
    <div class="vx-col w-full lg:w-1/3 mb-base" v-show="$auth.checkRoles(['CashflowWriter', 'Admin'])">
      <vx-card slot="no-body" :title="$t('CashFlow.Admin.Title')" class="text-center greet-user" v-show="$auth.checkRoles(['CashflowWriter', 'Admin'])">
        <ul class="vx-timeline">
          <li v-if="$auth.checkRoles(['CashflowWriter', 'Admin'])">
            <div class="timeline-icon bg-secondary">
              <feather-icon icon="LockIcon" svgClasses="text-white stroke-current w-5 h-5" />
            </div>
            <div class="timeline-info">
                <router-link to="/bsg/cashflow/admin/regions">{{ $t("CashFlow.Region.Title") }}</router-link>
            </div>
          </li>
          <li v-if="$auth.checkRoles(['CashflowWriter', 'Admin'])">
            <div class="timeline-icon bg-secondary">
              <feather-icon icon="LockIcon" svgClasses="text-white stroke-current w-5 h-5" />
            </div>
            <div class="timeline-info">
             <router-link to="/bsg/cashflow/admin/projects">{{ $t("CashFlow.Project.Title") }}</router-link>
            </div>
          </li>
        </ul>
      </vx-card>
    </div>

  </div>
</template>

<script>
import roles from './roles.js'
import pages from './pages.js'
import menuControl from '@/app/shared/components/lists/menu.vue'
import { odtHostname } from '@/environment/environment'
const cashFlowPages = new pages();

export default {
  components: {
    menuControl
  },
  mounted() {
    window.location.href = odtHostname + "/bsg/";
  },
  data () {
    return {
      roles,
      templateItems : cashFlowPages.getTemplateItems()
    }
  }
}
</script>
<style lang="scss">
.vx-timeline {
    margin-left: 3.5rem;
    padding-left: 40px;
    border-left: 2px solid #E5E8EB;

    li {
        position: relative;
        margin-bottom: 40px;

        .timeline-icon {
            position: absolute;
            top: 0;
            left: -4.3rem;
            border-radius: 50%;
            padding: .75rem;
            padding-bottom: 0.4rem;
        }

        .timeline-info {
          text-align: left;
          padding-top:0.4rem;
        }

        .activity-desc {
            font-size: .9rem;
        }

        .activity-e-time {
            font-size: .8rem;
        }
    }
}
</style>